export default __webpack_public_path__ + "static/media/credits_white.0e4e24f5.svg";